import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css'; // We'll create this or use index.css

const LandingPage = () => {
    return (
        <div className="landing-container">
            {/* Navigation */}
            <nav className="landing-nav">
                <div className="landing-nav-brand">
                    <img src="/logo-brand.png" alt="Wagoing Logo" className="landing-logo" />
                    <span>Wagoing</span>
                </div>
                <div className="landing-nav-links">
                    <a href="#features">Features</a>
                    <a href="#pricing">Pricing</a>
                    <Link to="/login" className="btn-login">Log In</Link>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Parking. <br/><span className="text-gradient">Made. Simple.</span></h1>
                    <p className="hero-subtitle">
                        Experience the ultimate ease of use in parking management. 
                        No high pressure sales. Just transparent, powerful tools for your lot. 
                        <strong>Wagoing is in final product testing and will be available soon.</strong>
                    </p>
                    <div className="hero-actions">
                        <Link to="/signup" className="btn-primary-large">Get Started Now</Link>
                        <a href="#pricing" className="btn-secondary-large">View Pricing</a>
                    </div>
                </div>
                <div className="hero-visual">
                    <div className="floating-card glass-card">
                        <div className="mockup-header">Dashboard Overview</div>
                        <div className="mockup-body">
                            <div className="mockup-stat">Available: <span style={{color: 'var(--success)'}}>42</span></div>
                            <div className="mockup-stat">Occupied: <span style={{color: 'var(--danger)'}}>18</span></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="features-section">
                <h2 className="section-title">Everything You Need. Nothing You Don't.</h2>
                <div className="features-grid">
                    <div className="feature-card glass-card">
                        <div className="feature-icon">🚙</div>
                        <h3>Valet Management</h3>
                        <p>Keep track of your lot and monitor employee usage in real time. Perfect for valet lot owners.</p>
                    </div>
                    <div className="feature-card glass-card">
                        <div className="feature-icon">🏢</div>
                        <h3>Multiple Organizations</h3>
                        <p>Manage multiple parking organizations from a single, unified admin dashboard.</p>
                    </div>
                    <div className="feature-card glass-card">
                        <div className="feature-icon">💳</div>
                        <h3>Seamless Checkout</h3>
                        <p>Customers can easily pay for parking via our self serve portal with just a few taps.</p>
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section id="pricing" className="pricing-section">
                <h2 className="section-title">Transparent Pricing. No Hidden Fees.</h2>
                <div className="pricing-grid">
                    <div className="pricing-card glass-card">
                        <div className="pricing-header">
                            <h3>Pay As You Go</h3>
                            <div className="price">7.5%<span>/transaction</span></div>
                        </div>
                        <ul className="pricing-features">
                            <li>✔️ 100% Transparent Pricing</li>
                            <li>✔️ No Hidden Fees or Extras</li>
                            <li>✔️ Full Self Serve Checkout</li>
                            <li>✔️ Ideal for standard parking lots</li>
                        </ul>
                        <Link to="/signup" className="btn-primary-large w-100">Choose Free</Link>
                    </div>

                    <div className="pricing-card glass-card featured-pricing">
                        <div className="pricing-badge">Most Popular</div>
                        <div className="pricing-header">
                            <h3>Valet Pro</h3>
                            <div className="price">$59<span>/month</span></div>
                        </div>
                        <ul className="pricing-features">
                            <li>✔️ Everything in Pay As You Go</li>
                            <li>✔️ Advanced Valet Tracking</li>
                            <li>✔️ Employee Usage Monitoring</li>
                            <li>✔️ Dedicated Admin Dashboard</li>
                        </ul>
                        <Link to="/signup" className="btn-primary-large w-100">Choose Pro</Link>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="landing-footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src="/logo-brand.png" alt="Wagoing Logo" />
                        <span>Wagoing</span>
                    </div>
                    <div className="footer-links">
                        <a href="#">Privacy Policy</a>
                        <a href="#">Terms of Service</a>
                        <a href="#">Contact Support</a>
                    </div>
                </div>
                <div className="footer-copyright">
                    &copy; {new Date().getFullYear()} Wagoing. All rights reserved.
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
